module.exports = __webpack_public_path__ + "img/wp-research.f31a5b3b.png";